!(function () {
  'use strict';
  const SELECTOR_SCALE = '[data-ticker-scale]';
  const SELECTOR_TEXT = '[data-ticker-text]';
  const ATTR_CLONE = 'data-clone';
  const ATTR_AUTOPLAY = 'autoplay';
  const ATTR_SPEED = 'speed';
  const CLASS_ANIMATED = 'ticker--animated';
  const CLASS_UNLOADED = 'ticker--unloaded';
  const CLASS_COMPARITOR = 'ticker__comparitor';
  const DEFAULT_SPEED = 1.63;
  const SPEED_DIVISOR = 100;
  /** Widescreen + short ticker copy (e.g. free-shipping line) could spawn dozens of clones; cap for DOM + a11y. */
  const MAX_MARQUEE_CLONES = 16;

  if (customElements.get('ticker-bar')) return;

  customElements.define(
    'ticker-bar',
    class extends HTMLElement {
      constructor() {
        super();
        this.autoplay = this.hasAttribute(ATTR_AUTOPLAY);
        this.scale = this.querySelector(SELECTOR_SCALE);
        this.text = this.querySelector(SELECTOR_TEXT);
        this.speed = this.hasAttribute(ATTR_SPEED) ? this.getAttribute(ATTR_SPEED) : DEFAULT_SPEED;
        if (this.text && this.scale) {
          this.comparitor = this.text.cloneNode(true);
          this.comparitor.classList.add(CLASS_COMPARITOR);
          this.comparitor.setAttribute('aria-hidden', 'true');
          this.appendChild(this.comparitor);
        }
        this.checkWidthEvent = this.checkWidth.bind(this);
      }

      connectedCallback() {
        this.checkWidth();
        requestAnimationFrame(() => this.checkWidth());
        this.addEventListener('theme:ticker:refresh', window.theme.debounce(() => this.checkWidthEvent(), 50));
        screen.orientation.addEventListener('change', this.checkWidthEvent);
        document.addEventListener('theme:resize:width', this.checkWidthEvent);
      }

      disconnectedCallback() {
        document.removeEventListener('theme:resize:width', this.checkWidthEvent);
      }

      checkWidth() {
        this.text = this.querySelector(SELECTOR_TEXT);
        this.scale = this.querySelector(SELECTOR_SCALE);
        if (!this.text || !this.scale) return;
        if (!this.comparitor) {
          this.comparitor = this.text.cloneNode(true);
          this.comparitor.classList.add(CLASS_COMPARITOR);
          this.comparitor.setAttribute('aria-hidden', 'true');
          this.appendChild(this.comparitor);
        }

        const padRaw = window.getComputedStyle(this).paddingLeft.replace('px', '');
        const pad = 2 * (Number.parseFloat(padRaw) || 0);
        const tickerWidth = Math.max(this.clientWidth || 0, 1);
        const textWidth = Math.max(this.text.clientWidth || 0, 64);
        const needsFill = tickerWidth - pad < this.comparitor.clientWidth;

        if (needsFill || this.autoplay) {
          this.text.classList.remove(CLASS_ANIMATED);
          this.scale.querySelectorAll(`[${ATTR_CLONE}]`).forEach((node) => node.remove());

          const rawRepeats = this.autoplay
            ? Math.floor((tickerWidth - pad) / textWidth)
            : 2;
          const repeatCount = Math.min(Math.max(rawRepeats, 2), MAX_MARQUEE_CLONES);

          if (this.autoplay || needsFill) {
            for (let i = 0; i <= repeatCount; i++) {
              const clone = this.text.cloneNode(true);
              clone.setAttribute(ATTR_CLONE, '');
              clone.setAttribute('aria-hidden', 'true');
              this.scale.appendChild(clone);
            }
          }

          const animationSeconds = ((this.text.clientWidth / SPEED_DIVISOR) * Number(this.speed)).toFixed(2);
          this.scale.style.removeProperty('--animation-time');
          this.scale.style.setProperty('--animation-time', `${animationSeconds}s`);
          this.scale.style.setProperty('--animation-speed', this.speed);
          this.scale.querySelectorAll(SELECTOR_TEXT).forEach((el) => {
            el.classList.add(CLASS_ANIMATED);
          });
          this.text.removeAttribute('aria-hidden');
        } else {
          this.text.classList.add(CLASS_ANIMATED);
          this.scale.querySelectorAll(`[${ATTR_CLONE}]`).forEach((node) => {
            node.parentNode.removeChild(node);
          });
          this.text.classList.remove(CLASS_ANIMATED);
        }

        this.scale.classList.remove(CLASS_UNLOADED);
      }
    }
  );
})();
